import { UserData } from '@telialt/utils/src/SSO/model';

import { LeadsApplicationFormType, LeadSmsConfirmRequestData, LeadSubmitRequestData } from './model';

declare global {
    interface Window {
        TeliaclientId: string;
    }
}

const getSegment = () => (window.leadSegment || 'b2c').toLowerCase();

const getCommonLeadFormData = () => {
    const formData = {
        p_tracker_client_id: window.TeliaclientId || '',
        p_segment: getSegment(),
        p_source_url: window.location.href || '',
    };

    return formData;
};

type GetLeadDataParams = {
    form: HTMLFormElement;
    leadText?: string;
    leadsType?: LeadsApplicationFormType;
    legalText?: string;
    serviceType?: string;
    possibilityComment?: string;
    addressText?: string;
    addressId?: string;
};

export const getLeadSubmitData = ({
    form,
    leadText,
    legalText,
    leadsType,
    serviceType,
    possibilityComment,
    addressText,
    addressId,
}: GetLeadDataParams): LeadSubmitRequestData => {
    const commonData = getCommonLeadFormData();

    const formData = new FormData(form);

    const leadData: LeadSubmitRequestData = {
        ...commonData,
        p_comment: (formData.get('p_comment') as string) || '',
        p_common_name: (formData.get('p_common_name') as string) || '',
        p_telephone_number: (formData.get('p_telephone_number') as string) || '',
        p_b2b_code: (formData.get('p_b2b_code') as string) || '',
        p_address_text: addressText || '',
        p_email: '',

        p_text_data: leadText || '',
        p_legal_text: legalText || '',
        p_service_type: serviceType || '',
        leads_type: leadsType || LeadsApplicationFormType.LeadsForm,
        possibility_comment: possibilityComment || undefined,
        p_address_id: addressId || '',
    };

    return leadData;
};

export const getLeadSmsConfirmData = ({
    form,
    leadText,
    legalText,
    serviceType,
}: GetLeadDataParams): LeadSmsConfirmRequestData => {
    const commonData = getCommonLeadFormData();

    const formData = new FormData(form);

    const confirmData = {
        ...commonData,
        p_confirmation_code: (formData.get('p_confirmation_code') as string) || '',

        p_text_data: leadText || '',
        p_legal_text: legalText || '',
        p_service_type: serviceType || '',
    };

    return confirmData;
};

export const getLegaltext = (helpText: string, helpTooltip: string) => {
    return `${helpText} ${helpTooltip}`.trim();
};

export const mapUserDataToSubmitData = (
    userData?: UserData | null,
    prefilledComment?: string,
): LeadSubmitRequestData | undefined => {
    if (!userData) {
        return undefined;
    }

    const commonData = getCommonLeadFormData();

    return {
        ...commonData,

        p_common_name: userData.fullName,
        p_telephone_number: userData.contactNumber,
        p_email: userData.email,
        p_comment: prefilledComment,

        p_address_text: '',
        p_b2b_code: '',
        p_text_data: '',
        p_legal_text: '',
        p_service_type: '',
    };
};
